/** Formats a URI based on the event title */
export default function formatEventURI(title: string): string {
	return title
		.replace(/ /g, '-') // Translate all spaces to hyphen
		.replace(/[^A-Za-z0-9-_+]/g, '') // Remove characters not URI friendly
		.replace(/-+/g, '-') // Reduce all multiple hyphen sequences to single hyphen
		.replace(/^-/, '') // Remove leading hyphen if present
		.replace(/-$/, ''); // Remove trailing hyphen if present
}
